let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6E2pS"), load("daCl8"), load("aZinD"), load("6qah4"), load("9QyoN")]).then(() => parcelRequire('bm1ob'));